import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    localidades: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    provincia: null,
    pais: null,

    provinciaId: 0,
    localidadesProvincia: [],
    localidadesProvinciaList: [],

    list: [],
    selectList: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.localidades = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.provincia = null;
        state.pais = null;
    },
    
    'INICIALIZAR_LOCALIDADES'(state) {
        state.localidades = [];
    },
    'LOCALIDADES'(state, localidades) {
        state.localidades = localidades;
    },
    'LOCALIDADES_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LOCALIDADES_PROVINCIA'(state, provinciaId) {
        state.provinciaId = provinciaId;
        state.localidadesProvincia = [];
        state.localidadesProvinciaList = [];
    },
    'SET_LOCALIDADES_PROVINCIA'(state, list) {
        state.localidadesProvincia = list;
        state.localidadesProvinciaList = list.map(localidad => localidad.nombre.trim());
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(localidad => localidad.nombre.trim());
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getLocalidades: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LOCALIDADES');

            let queryString = ''

            if (state.paginaActual != 0) {
              queryString = '?'
                + 'pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.nombre != '') {
                if (queryString == '') {
                    queryString += '?nombre=' + state.nombre;
                } else {
                    queryString += '&nombre=' + state.nombre;
                }
            }
            if (state.provincia) {
                if (state.provincia.id != 0) {
                    queryString += '&provinciaId=' + state.provincia.id;
                }
            }
            if (state.pais) {
                if (state.pais.id != 0) {
                    queryString += '&paisId=' + state.pais.id;
                }
            }
      
            apiAxios.get('localidades' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('LOCALIDADES_PAGINATION', params);
                    }
                    commit('LOCALIDADES', res.data)
                    
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })                
    },
    getLocalidadesProvincia: ({commit}, provinciaId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LOCALIDADES_PROVINCIA', provinciaId);

            apiAxios.get('localidades/provincia/' + provinciaId + '/list')
                .then(res => {
                    commit('SET_LOCALIDADES_PROVINCIA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    getList: ( { commit } ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('localidades/list')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    provinciaId (state) {
        return state.provinciaId;
    },
    localidadesProvincia (state) {
        return state.localidadesProvincia;
    },
    localidadesProvinciaList (state) {
        return state.localidadesProvinciaList;
    },
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}